<template>
  <div class="data_brain_wrap">
    <div class="brain_title">{{ $t('todo.title') }}</div>
    <!-- <div class="brain_desc">{{ $t('todo.description') }}</div> -->

    <el-row class="card_wrap" type="flex">
      <el-col
        class="brain_item"
        :lg="7"
        :sm="11"
        :xs="11"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <div class="image_wrap">
          <img :src="item.img" />
        </div>
        <div class="item_title" @click="handleTitle(item)">{{ $t(`todo.services.${item.type}.title`) }}</div>
        <!-- <div class="item_desc">{{ $t(`todo.services.${item.type}.desc`) }}</div>
        <div class="item_navigate" @click="handleNavigate(item)">{{ $t('todo.learnMore') }}</div>
        <div class="item_bg"></div> -->
      </el-col>
    </el-row>

  </div>
</template>

<script>
export default {
  name: 'TodoShow',
  data() {
    return {
      cardList: [
        {
          type: 'SustainableSupplyChainCloud',
          img: require('@/assets/img/hly/new/首页/低碳类.jpg'),
          desc: '',
        },
        {
          type: 'toolCloud',
          img: require('@/assets/img/hly/new/首页/能源类.png'),
          desc: ''
        },
        {
          type: 'OrganizeCarbonInventoryInspectionTraining',
          img: require('@/assets/img/hly/new/首页/绿建类.png'),
          desc: ''
        },
        {
          type: 'ProductCarbonFootprintTraining',
          img: require('@/assets/img/hly/new/首页/合规生产类.png'),
          desc: ''
        },
        {
          type: 'ESGManagementTheoryandPracticeTraining',
          img: require('@/assets/img/hly/new/首页/追溯管理类.png'),
          desc: ''
        },
        {
          type: 'EnergyAuditTraining',
          img: require('@/assets/img/hly/new/首页/社会责任类.png'),
          desc: ''
        },
        {
          type: 'EnvironmentalManagementSystemInternalAuditorTraining',
          img: require('@/assets/img/hly/new/首页/健康和安全类.png'),
          desc: ''
        },
        {
          type: 'InternalAuditorTrainingForEnergyManagementSystem',
          img: require('@/assets/img/hly/new/首页/合规风险类.png'),
          desc: ''
        },
        {
          type: 'ISCCsystemInternalAuditorTraining',
          img: require('@/assets/img/hly/new/首页/能力建设类.png'),
          desc: ''
        },
        // {
        //   type: 'EcovadisDeclarationTraining',
        //   img: require('@/assets/img/carbon/service-10.png'),
        //   desc: ''
        // },
        // {
        //   type: 'CBAMapplicationTraining',
        //   img: require('@/assets/img/carbon/service-11.png'),
        //   desc: ''
        // },
        // {
        //   type: 'EUBatteryActTraining',
        //   img: require('@/assets/img/carbon/service-12.png'),
        //   desc: ''
        // },
        // {
        //   type: 'CustomizedTrainingCamp',
        //   img: require('@/assets/img/carbon/service-16.jpg'),
        //   desc: ''
        // },
        // {
        //   type: 'more',
        //   img: require('@/assets/img/carbon/service-20.png')
        // },
        // {
        //   type: 'more',
        //   img: require('@/assets/img/carbon/service-20.png')
        // },
      ],
    }
  },
  methods:{
    handleNavigate(item){
      switch (item.type) {
        case 'SustainableSupplyChainCloud':
          this.$router.push('/SustainableSupplyChainCloud').catch((v) => {})
          break;
        case 'toolCloud':
          this.$router.push('/toolCloud').catch((v) => {})
          break;
        case 'cbam':
          this.$router.push('/joinUs').catch((v) => {})
          break;
        case 'esgDueDiligence':
          this.$router.push('/trial').catch((v) => {})
          break;
          case 'ecoVadis':
          this.$router.push('/production/ecoVadis').catch((v) => {})
          break;
          case 'puoEarth':
          this.$router.push('/').catch((v) => {})
          break;
          case 'SBTi':
          this.$router.push('/').catch((v) => {})
          break;
          case 'cdpDep':
          this.$router.push('/').catch((v) => {})
          break;
          case 'epdDep':
          this.$router.push('/').catch((v) => {})
          break;
          case 'supplyChain':
          this.$router.push('/').catch((v) => {})
          break;
          case 'apiIntegration':
          this.$router.push('/').catch((v) => {})
          break;
          case 'aiRedC':
          this.$router.push('/aiSearch').catch((v) => {})
          break;
          case 'redcPlus':
          this.$router.push('/production/redcPlus').catch((v) => {})
          break;
          case 'lca':
          this.$router.push('/').catch((v) => {})
          break;
          case 'ccer':
          this.$router.push('/production/ccer').catch((v) => {})
          break;
          case 'pas':
          this.$router.push('/').catch((v) => {})
          break;
      }
    },
    handleTitle(item){
      console.log('item', item.type);
      
      switch (item.type) {
        // 低碳类
        case 'SustainableSupplyChainCloud':
          this.$router.push('/lowCarbonCategory').catch((v) => {})
          break;
          // 能源类
        case 'toolCloud':
          this.$router.push('/energyCategory').catch((v) => {})
          break;
          // 绿建类
        case 'OrganizeCarbonInventoryInspectionTraining':
          this.$router.push('/greenBuildingCategory').catch((v) => {})
          break;
          // 合规生产类
        case 'ProductCarbonFootprintTraining':
          this.$router.push('/complianceProductionCategory').catch((v) => {})
          break;
          // 追溯管理类
          case 'ESGManagementTheoryandPracticeTraining':
          this.$router.push('/traceabilityManagementCategory').catch((v) => {})
          break;
          // 社会责任类
          case 'EnergyAuditTraining':
          this.$router.push('/socialResponsibilityCategory').catch((v) => {})
          break;
          // 健康和安全类
          case 'EnvironmentalManagementSystemInternalAuditorTraining':
          this.$router.push('/healthAndSafetyCategory').catch((v) => {})
          break;
          // 合规风险类
          case 'InternalAuditorTrainingForEnergyManagementSystem':
          this.$router.push('/complianceRiskCategory').catch((v) => {})
          break;
          // 能力建设类
          case 'ISCCsystemInternalAuditorTraining':
          this.$router.push('/capacityBuildingCategory').catch((v) => {})
          break;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding: 50px 0;
  background: #e8eef2;
  text-align: center;

  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40px;
    }
  }

  .card_wrap {
    width: 70%;
    flex-wrap: wrap;
    margin: 0 auto;
    justify-content: space-around;

    @media screen and (max-width: 768px) {
      width: 95%;
    }

    .brain_item {
      transition: background-color 1s;
      padding: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      overflow: hidden;
      height: 320px;

      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        border-radius: 10px;
        margin-top: 20px;
        height: auto;
      }

      .image_wrap {
        width: 100%;
        height: 50%;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .item_title {
        width: 100%;
        height: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        font-weight: bold;
        color: #203040;
        text-align: center;
        margin-top: 10px;

        @media screen and (max-width: 768px) {
          font-size: 1rem;
          padding: 10px;
        }
      }
      .item_title:hover {
        color: #339216;
        cursor: pointer;
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        word-break: break-all;
        overflow-wrap: break-word;

        @media screen and (max-width: 768px) {
          min-height: 110px;
          text-indent: 2em;
          font-size: 12px;
        }
      }

      .item_navigate {
        width: 130px;
        height: 30px;
        color: #0a7fd7;
        border-radius: 20px;
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;

        @media screen and (max-width: 768px) {
          margin-bottom: 10px;
          font-size: 14px;
        }
      }

      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
    }
  }
}
</style>
